export default "__VITE_ASSET__DiQg3Zl$__"